import React from 'react'
import { ImageMedia } from '../../components/imports';
import ThisProject from '../ThisProject';

const Content = () => {

  // const { projectId } = useParams();
  // const prLink = useLink();
  // const thisProject = projects.find(project => prLink(project.client) === projectId);


  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (


        <div className='projectContent'>

          <div className='resp block items-center w-full paddingY'>
            <ImageMedia src={require('./assets/_cover_.jpg')} className="mx-auto w-full rounded-lg max-w-4xl" />
          </div>
        </div>


      )}

    </ThisProject>

  )
}


export default Content